/* global ITPContactForm, grecaptcha */
const formWrappers = document.querySelectorAll('.contact-form-wrapper');

if (formWrappers.length > 0) {
  Array.from(formWrappers).forEach((formWrapper) => {
    formWrapper.classList.remove('no-js');

    const form = formWrapper.querySelector('.contact-form');
    const responseEl = formWrapper.querySelector('.contact-form-response');
    const submitButton = formWrapper.querySelector('.contact-form-submit');
    const submitButtonInitialValue = submitButton.value;
    const submitButtonSendingValue = submitButton.getAttribute('data-sending-value');

    const lockForm = () => {
      form.dataset.submitting = '1';
      submitButton.disabled = true;
      submitButton.value = submitButtonSendingValue;
    };

    const unlockForm = () => {
      form.dataset.submitting = '0';
      submitButton.disabled = false;
      submitButton.value = submitButtonInitialValue;
    };

    const removeErrorClasses = () => {
      const errorFields = form.querySelectorAll('.has-error');
      errorFields.forEach((field) => {
        field.classList.remove('has-error');
        field.removeAttribute('aria-invalid');
      });
    };

    form.addEventListener('input', (e) => {
      const field = e.target.closest('.has-error');
      if (field) {
        field.classList.remove('has-error');
        field.removeAttribute('aria-invalid');
      }
    });

    const getReCaptchaToken = async () => {
      if (!ITPContactForm.recaptchaSiteKey || !window.grecaptcha?.execute) {
        return { verified: true, token: null };
      }

      try {
        const token = await grecaptcha.execute(ITPContactForm.recaptchaSiteKey, {
          action: 'contact_form',
        });
        return { verified: true, token };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('reCAPTCHA error:', error);
        return { verified: false, token: null };
      }
    };

    const handleResponse = (result) => {
      if (result.status === 'success') {
        form.remove();
        responseEl.innerText = result.message || ITPContactForm.successMessage;
        return;
      }

      responseEl.innerText = result.message || ITPContactForm.errorMessage;

      if (result.field) {
        const field = form.elements.namedItem(result.field);
        if (field) {
          field.focus();
          field.classList.add('has-error');
          field.setAttribute('aria-invalid', 'true');
        }
      }

      unlockForm();
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      removeErrorClasses();
      responseEl.innerText = '';

      if (form.dataset.submitting === '1') {
        return;
      }

      lockForm();

      const formData = new FormData(form);
      const plainData = Object.fromEntries(formData.entries());

      const recaptcha = await getReCaptchaToken();
      if (recaptcha.token) {
        plainData.recaptcha_token = recaptcha.token;
      }

      if (!recaptcha.verified) {
        responseEl.innerText = ITPContactForm.errorMessage;
        unlockForm();
        return;
      }

      try {
        const response = await fetch(ITPContactForm.apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': ITPContactForm.nonce,
          },
          body: JSON.stringify(plainData),
        });

        const result = await response.json();
        handleResponse(result);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Contact form submission error:', error);
        responseEl.innerText = ITPContactForm.errorMessage;
        unlockForm();
      }
    });
  });
}
